define('home/mixins/withItemRemovalSkipped',[
], function (
) {
    'use strict';

    /**
     * A mixin for a Marionette Collection View (also works with a FetchableCollectionView)
     * that prevents collection item views from being removed when the corresponding model
     * is removed from the collection.
     * Used primarily for views where the item view can toggle the included state of the
     * model in the collection. It's jarring to click a button and have a view removed.
     */
    var withItemRemovalSkipped = function () {
        var _addItemView = this.addItemView;
        this.addItemView = function (item) {
            if (this.children.findByModel(item))
                // Don't add duplicate views. This isn't a problem in the default
                // collection view implementation because the item views directly
                // represent the collection, and the collection does not contain
                // duplicates.
                return;

            return _addItemView.apply(this, arguments);
        };

        var _removeItemView = this.removeItemView;
        this.removeItemView = function () {
            // Kill the default handling that removes a card when the forum is
            // no longer followed.
            if (this.isShowingNonItemView && this.isShowingNonItemView())
                return _removeItemView.apply(this, arguments);
        };
    };

    return withItemRemovalSkipped;
});

